<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>William John Little, Sigmund Freud, William Osler, Dr Pierre Maroteaux, Jean Lobstein, Wilem Vrolik, David Silence, Jean Martin Charcot, Karl Landsteiner, Erwin Popper, Dr Robert Whytt, Sir Charles Bell, John Hughlings Jackson, Dr Dorothy Hansine Anderson, Dr Paul Di Saint Agnese, Rudolf Ludwig Virchow, Dr James Morton, Guilame Benjamin Duchenne, George’s Giles de la Tourette, John Bulwer, Thomas Braidwood, Thomas Gallaudet, Alice Cogswell, Louis Braille, Edward Rushton, George Huntington, Fred Plum, Wilhelm Conrad Roentgen, James Parkinson, John Langdon Down, Professor Jerômé Lejeune.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1f3c9d20